import React from 'react';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import { grayDark } from 'design-system/colors';

type BugReportIconProps = {
  color?: string;
  size?: "small" | "medium";
};

const BugReportIcon = (props: BugReportIconProps) => {
  const { color = grayDark, size = "small" } = props;

  return (
    <BugReportOutlinedIcon 
      sx={{ 
        color, 
        height: size === "small" ? 18 : 24,
        width: size === "small" ? 18 : 24,
      }} 
    />
  );
};

export default BugReportIcon;
